import React from "react";
import { TemplateElevenResumeSection } from "./common";
import { View } from "@react-pdf/renderer";
import { ResumePDFText, ResumePDFHighlightableText } from "../ResumePDF/common";

const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateElevenResumeSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && ((enableHighlight || enableMistakeHighlight) ? (
          <ResumePDFHighlightableText
            text={summary}
            section="profile"
            itemIndex={null}
            enableMistakeHighlight={enableMistakeHighlight}
          />
        ) : (
          <ResumePDFText>{summary}</ResumePDFText>
        ))}
      </View>
    </TemplateElevenResumeSection>
  );
};

export default Summary;
